/*
 * The design system's breakpoints. tailwind.config.js reads these for the
 * `ds-*:` variants, and useDsScreen reads them for the layouts that have to
 * pick in JS -- one list, so the two can't drift.
 */
export const screens = {
  'ds-narrow': '450px',
  'ds-pair': '1150px',
  'ds-map-overlay': '1280px',
};
